import { useState } from 'react'
import { AButton } from 'views/components/Analytics'
import { CarrierDocsInfo } from 'views/pages/LogisticsKR/types'
import { UploadMissingDocModal } from './UploadMissingDocModal'
import { useTranslation } from 'react-i18next'

type Props = {
  docsInfo: CarrierDocsInfo
  refetch: () => void
}
export const UploadDocBtn = ({ docsInfo, refetch }: Props) => {
  const [showModal, setShowModal] = useState(false)
  const { t } = useTranslation('common')
  return (
    <>
      <AButton id="uploadMissingDocs" color="secondary" size="small" onClick={() => setShowModal(true)}>
        {t('upload')}
      </AButton>
      {showModal && (
        <UploadMissingDocModal carrierDocsInfo={docsInfo} onClose={() => setShowModal(false)} onSuccess={refetch} />
      )}
    </>
  )
}
